import { format, setHours, setMinutes, isValid } from 'date-fns';

export function parseTime(time) {
	const [hour, minute] = (time || '').split(':');
	return setMinutes(setHours(new Date(), hour), minute);
}

export function getHourString(hour) {
	if (!hour) {
		return 'closed';
	}
	if (hour.appointmentOnly) {
		return 'By Appointment Only';
	}

	const openTime = parseTime(hour.open);
	const closeTime = parseTime(hour.closed);

	// date-fns v3 throws on an invalid date (v1 returned "Invalid Date"). Empty or
	// missing open/closed values mean the day has no usable range — treat as closed
	// rather than 500 the facility page.
	if (!isValid(openTime) || !isValid(closeTime)) {
		return 'closed';
	}

	const openStr = format(openTime, 'h:mm aaa');
	const closeStr = format(closeTime, 'h:mm aaa');

	return openStr === closeStr ? 'closed' : `${openStr} - ${closeStr}`;
}
